var bookModule = angular.module ( 'bookModule' , 
    [ 'duScroll' ] );

bookModule.factory('getChapterConfig', 
    ['$http', 
    function ($http) {
            var chapterConfigData = function () {
                return $http.get('./domains.json');
            };
            return { chapterConfigData: chapterConfigData };
    } ]
);


bookModule.controller('abstractController', 
    ['$scope', 'getChapterConfig', '$state', 'contentService', '$document', '$window',
    function ($scope, getChapterConfig, $state, contentService, $document, $window) {
        $scope.ctrl = { };
        var vm = $scope.ctrl;
        
        /** this method can be used to setup the controller after the contents has been loaded
         */
        vm.controllerSetup = function () { };        

        /** this method will extract the Html-Snippet element from an element (Kentico Page content) 
         */
        vm.extractHtmlSnippetFromKenticoPage = function (kenticoPageElement) {
            var htmlSnippet = kenticoPageElement.querySelector('div#html-snippet');
            var htmlSnippetContents = htmlSnippet == null
                ? kenticoPageElement
                : htmlSnippet.innerHTML;
            return htmlSnippetContents;
        };

        $scope.$on('$stateChangeError', function() {
            //catch error
        });

        /** stateChangeStart will trigger on initial page load or when clicking ui-sref (or hashbang links)
         * This method ensures that the content of the application has been loaded successfully
         */
        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if (typeof($scope.contents) === 'undefined') {
                event.preventDefault();
                contentService.getContentPromise()
                    .then(function(result) {
                        $scope.contents = result;
                        vm.controllerSetup();
                        // Resume state transition
                        $state.go(toState.name, toParams);
                    });
            }
            
        });
        
        /** stateChangeSuccess will trigger on initial page load or when clicking ui-sref (or hashbang links)
         * This method ensures that the controller variables are in sync with the current state.
         */
        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){ 
            vm.updateControllerStateParams(toParams);
        });

        /** this method can be used to read params from the state change
         * toParams - variable containing all of the params defined for the state in app.js
         * This method should be override by child classes.
         */
        vm.updateControllerStateParams = function (toParams) { };

        /** https://github.com/oblador/angular-scroll
         * @author  oblador - aka. Joel Arvidsson
         * @version 1.60, 05/05/07
         * @since   JDK1.0
         * 
         * This method will add a function to scoll to the anchor/element that matches the input Id
         */
        vm.scrollToId = function (idOfAnchor) {
            var element = document.getElementById(idOfAnchor);
            var elementHeight = $('#' + idOfAnchor).outerHeight();
            var menuHeight = $('header .top-bar-container .top-bar-container-inner').height();
            var smallestElementOffsetThatStillShowsHeading = Math.max($(window).height() - elementHeight, 0);
            var offset = smallestElementOffsetThatStillShowsHeading + menuHeight;
            var duration = 1000; //milliseconds
            $document.scrollToElement(element, smallestElementOffsetThatStillShowsHeading, duration);
        }
        vm.scrollToDictionary = function () {
            vm.scrollToId('dictionary');
        }
    } ]
);
